import { render, staticRenderFns } from "./drag-file-upload.vue?vue&type=template&id=5deaa5da&scoped=true&lang=pug&"
import script from "./drag-file-upload.vue?vue&type=script&lang=ts&"
export * from "./drag-file-upload.vue?vue&type=script&lang=ts&"
import style0 from "./drag-file-upload.vue?vue&type=style&index=0&id=5deaa5da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deaa5da",
  null
  
)

export default component.exports